import React from "react";
import { useLocation } from "react-router-dom";
import NotificationModal from "./NotificationModal";
import { useAudioManager } from "../hooks/useAudioManager";
import { useTabVisibility } from "../hooks/useTabVisibility";
import { useSocketNotifications } from "../hooks/useSocketNotifications";
import { EXCLUDED_ROUTES } from "../config/constants";

const NotificationProvider = ({ children }) => {
  const location = useLocation();
  const isTabActive = useTabVisibility();
  const { hasInteracted, playSuccessSound, playErrorSound } = useAudioManager();
  
  const {
    notificationState,
    closeSuccessModal,
    closeErrorModal,
  } = useSocketNotifications({
    hasInteracted,
    isTabActive,
    playSuccessSound,
    playErrorSound,
  });

  const shouldShowNotifications = !EXCLUDED_ROUTES.includes(location.pathname);

  return (
    <>
      {children}
      {shouldShowNotifications && (
        <>
          <NotificationModal
            isOpen={notificationState.successModalOpen}
            onRequestClose={closeSuccessModal}
            onClose={closeSuccessModal}
            type="success"
            user={notificationState.user}
          />
          <NotificationModal
            isOpen={notificationState.errorModalOpen}
            onRequestClose={closeErrorModal}
            onClose={closeErrorModal}
            type="error"
            user={notificationState.user}
          />
        </>
      )}
    </>
  );
};

export default NotificationProvider;
